import heroMediaConfig from './heroMedia.json';

export type HeroVertical = 'office' | 'nightclub' | 'resto';

export const HERO_MEDIA = heroMediaConfig;

export function getHeroVideoSrc(vertical: Exclude<HeroVertical, 'resto'>): string {
  return HERO_MEDIA[vertical].video;
}

export function getHeroSideImage(vertical: HeroVertical): string {
  return HERO_MEDIA[vertical].sideImage;
}
